import { z } from "zod";

// A Select cleared with its "×" reports `undefined`, not `null`: `.nullish()` accepts both,
// where `.nullable()` made the form invalid and the sync button silently inert.
export const conformitSyncSchema = z.object({
  schemaId: z.string().nullish(),
  withVision: z.boolean(),
  skipExisting: z.boolean(),
  limitEnabled: z.boolean(),
  maxRecords: z.number().int().min(1).max(10000),
});

export type ConformitSyncForm = z.infer<typeof conformitSyncSchema>;

export const conformitSyncDefaultValues: ConformitSyncForm = {
  schemaId: "cadenassage", // Default schema for lockout procedures
  withVision: true,
  skipExisting: true,
  limitEnabled: false,
  maxRecords: 10,
};
